import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowRightIcon = ({ color = '#FFB766' }) => {
    return (_jsx("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 24 20", fill: "none" }, { children: _jsx("path", { d: "M9 5L15 12L9 19", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
